import { render, staticRenderFns } from "./ViewportWidth.vue?vue&type=template&id=6149b372"
import script from "./ViewportWidth.vue?vue&type=script&lang=js"
export * from "./ViewportWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports